import React from 'react';
import { Link, Button } from '@vp/swan';
import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';
import useSiteData from '../../../hooks/useSiteData';

const OrderDetailsCTA = ({ orderId, ...buttonProps }) => {
  const [orderDetailsMessages] = useTranslations(['orderDetailsMessages']);
  const { externalAppNavigation: nav } = useSiteData();
  const orderDetailsUrl = nav.orderDetails;

  return (
    <Button
      render={props => (
        <Link
          href={`${orderDetailsUrl}?orderId=${orderId}`}
          className={props.className}
        >
          {props.children}
        </Link>
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...buttonProps}
    >
      {orderDetailsMessages.viewOrderDetails}
    </Button>
  );
};

export default OrderDetailsCTA;

OrderDetailsCTA.propTypes = {
  orderId: PropTypes.string.isRequired,
  buttonProps: PropTypes.any,
};
